import { render } from "./SrcBackground.vue?vue&type=template&id=cfa1f57c"
import script from "./SrcBackground.vue?vue&type=script&lang=js"
export * from "./SrcBackground.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__